import { Patch } from "../http/httpVerbs";

export const apiUpdateCommunityCreator = async (communityId, creatorId, updateData) => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/comunidades/${communityId}/creators/${creatorId}`;
        const response = await Patch(url, updateData);
        return response;
    } catch (error) {
        console.error("Error updating community creator:", error);
        throw error;
    }
};
